import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Paper,
  TextField,
  Typography,
  Stack,
  Button,
  Divider,
} from "@mui/material";
import { updateOrderdata } from "../../store/slices/orderSlice";
import { showAlert } from "../../store/slices/alertSlice";
import { useValidateCouponCode } from "./vanuser.hooks";
import { constants } from "../../constants";

export default function Discount() {
  const dispatch = useDispatch();
  const orderData = useSelector((state) => state.order);

  const subtotalItems = orderData.order_details.reduce(
    (sum, item) => sum + item.orderQty * item.unitprice,
    0
  );

  const subtotal =
    subtotalItems -
    ((orderData.discountamount || 0) + (orderData.coupon_discount_amount || 0));

  const { mutate: validateCoupon, isLoading } = useValidateCouponCode({
    onSuccess: (res) => {
      if (res.coupon_discount_amount) {
        dispatch(
          updateOrderdata({
            field: "coupon_discount_amount",
            value: res.coupon_discount_amount,
          })
        );
        dispatch(updateOrderdata({ field: "coupon_validation_status", value: 1 }));
        dispatch(
          showAlert({
            severity: constants.SUCCESS,
            title: res.message,
          })
        );
      }
    },
    onError: (error) => {
      dispatch(updateOrderdata({ field: "coupon_discount_amount", value: 0 }));
      dispatch(updateOrderdata({ field: "coupon_validation_status", value: 0 }));
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Failed to validate coupon details. Please try again.";

      dispatch(
        showAlert({
          severity: "error",
          title: message,
        })
      );
    },
  });

  if (!orderData.order_details || orderData.order_details.length === 0) {
    return null;
  }
  return (
    <Paper
      sx={{
        mt: 3,
        p: 3,
        borderRadius: 3,
        boxShadow: 3,
        backgroundColor: "#fafafa",
      }}
    >
      <Typography variant="h6" fontWeight="bold" mb={2}>
        Order Summary
      </Typography>
  
      {/* Subtotal */}
      <Stack direction="row" justifyContent="space-between" mb={1}>
        <Typography>Items Subtotal</Typography>
        <Typography fontWeight="bold">€ {subtotalItems.toFixed(2)}</Typography>
      </Stack>

      {/* Coupon Section */}
  <Stack
        direction="row"
    alignItems="center"
        spacing={1}
    justifyContent="space-between"
        mb={1}
  >
        <Stack direction="row" spacing={1} alignItems="center">
          <TextField
            size="small"
            placeholder="Coupon code"
            value={orderData.coupon_code}
            onChange={(e) =>
              dispatch(
                updateOrderdata({
                  field: "coupon_code",
                  value: e.target.value || "",
                })
              )
            }
            sx={{
              width: 100, // narrower width
              '& .MuiInputBase-input': {
                padding: '4px 6px', // reduce padding
                fontSize: '0.8rem'  // smaller font
              }
            }}
          />
          <Button
            variant="contained"
            size="small"
            disabled={isLoading || !orderData.coupon_code}
            onClick={() =>
              validateCoupon({
                coupon_code: orderData.coupon_code,
                order_price: subtotalItems,
              })
            }
            
          >
            {isLoading ? "..." : "Apply"}
          </Button>
        </Stack>
        <Typography color="error" fontWeight="bold">
          - € {orderData.coupon_discount_amount || 0}
        </Typography>
      </Stack>

      {/* Round Off */}
      <Stack direction="row" justifyContent="space-between" mb={1}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography>Round Off</Typography>
      <TextField
        type="number"
        size="small"
        value={orderData.discountamount}
        onChange={(e) =>
              dispatch(
                updateOrderdata({
                  field: "discountamount",
                  value: parseFloat(e.target.value) || 0,
                })
              )
        }
        sx={{
              width: 100, // narrower width
          '& .MuiInputBase-input': {
            padding: '4px 6px', // reduce padding
            fontSize: '0.8rem'  // smaller font
          }
        }}
      />
        </Stack>
        <Typography fontWeight="bold">
          € {orderData.discountamount || 0}
        </Typography>
    </Stack>

      <Divider sx={{ my: 2 }} />

      {/* Total */}
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h6" fontWeight="bold">
          Total Payable
        </Typography>
        <Typography variant="h6" fontWeight="bold" color="primary">
          € {subtotal.toFixed(2)}
</Typography>
  </Stack>
</Paper>

  );
}
